import React from "react";

/**
 * ScaleInput — 5 large tap-friendly buttons for 1-5 scale answers.
 * Active value = solid gold; inactive = subtle border.
 * `leftLabel` / `rightLabel` are shown under the scale.
 */
export function ScaleInput({
  value,
  onChange,
  leftLabel,
  rightLabel,
  testIdPrefix,
}) {
  return (
    <div className="w-full" data-testid={`${testIdPrefix}-scale`}>
      <div className="grid grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((n) => {
          const active = value === n;
          return (
            <button
              type="button"
              key={n}
              onClick={() => onChange(n)}
              data-testid={`${testIdPrefix}-scale-${n}`}
              aria-pressed={active}
              className={`relative h-14 rounded-2xl text-base font-medium transition-all duration-200 active:scale-[0.97] ${
                active
                  ? "bg-[#F4C95D] text-[#0F172A] shadow-[0_8px_24px_-14px_rgba(244,201,93,0.9)]"
                  : "bg-white/[0.03] border border-white/10 text-white/70 hover:text-white hover:bg-white/[0.06] hover:border-white/20"
              }`}
              style={{ letterSpacing: "-0.01em" }}
            >
              {n}
            </button>
          );
        })}
      </div>
      <div
        className="mt-3 flex items-center justify-between text-[11px] text-[#94A3B8]"
        style={{ letterSpacing: "0.02em" }}
      >
        <span>{leftLabel}</span>
        <span>{rightLabel}</span>
      </div>
    </div>
  );
}
